import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next'; 

const HomepageComp6 = () => {
    const { t } = useTranslation(); 
    const ref = useRef();
    const [isVisible, setIsVisible] = useState(false);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.unobserve(entry.target);
            }
        });
    });

    useEffect(() => {
        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [ref]);

    return (
        <div className={`homepage-component-container homepage-comp6-container ${isVisible ? 'fade-in' : ''}`} ref={ref}>
            <div className='homepage-comp6-div1'>
                <h2 className='homepage-title2'>
                    {t('homepage.comp6.title')}
                </h2>
                <a className='homepage-link1 z-2 relative' href="/contact">
                    {t('homepage.comp6.linkBtn')}
                </a>
            </div>
        </div>
    )
}

export default HomepageComp6;